import { type IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import UserContext from '~/context/common/UserContext';
import { ListenerEvent, type ListenerEventType } from './constants';

type FetchFavoritesPayload = {};

function isFavoriteChangedMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, FetchFavoritesPayload> {
  return (
    message.event === ListenerEvent.FavoriteAdded ||
    message.event === ListenerEvent.FavoriteRemoved
  );
}

export default function useFetchFavoritesHandler(): MessageHandler<
  ListenerEventType,
  FetchFavoritesPayload
> {
  const { triggerFetchFavorites } = useContext(UserContext);

  return useMemo(
    () => new MessageHandler(isFavoriteChangedMessage, triggerFetchFavorites),
    [triggerFetchFavorites]
  );
}
